// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { useState } from 'react';

import OtpInstructions from './OtpInstructions';
import OtpVerification from './OtpVerification';

enum OtpStep {
  INSTRUCTIONS = 'INSTRUCTIONS',
  VERIFICATION = 'VERIFICATION',
}

const Otp = () => {
  const [step, setStep] = useState(OtpStep.INSTRUCTIONS);

  const handleContinue = () => {
    setStep(OtpStep.VERIFICATION);
  };

  return (
    <>
      {step === OtpStep.INSTRUCTIONS && <OtpInstructions onContinue={handleContinue} />}
      {step === OtpStep.VERIFICATION && <OtpVerification />}
    </>
  );
};

export default Otp;
